import React, { useRef, useEffect } from "react";
import { FileService } from "../../../services/SubmissionService";

export default function DocumentView({
    submissionId,
    documentId,
    filename,
}: {
    submissionId: string;
    documentId: string;
    filename: string;
}) {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        FileService.get({
            submissionId: submissionId,
            documentId: filename,
            source: "",
        }).then(
            (resp) => {
                resp.json().then((json) => {
                    console.log(json);
                    if (iframeRef && iframeRef.current)
                        iframeRef.current.src = json.url;
                });
            },
            (error) => {
                console.log(error);
            }
        );
    }, [submissionId, documentId]);

    return (
        <div className="card">
            <div className="card-body">
                <iframe
                    title={filename}
                    ref={iframeRef}
                    style={{ height: "800px", width: "100%" }}
                ></iframe>
            </div>
        </div>
    );
}
